/**
 * Pick Your Own — full article page for the "Pick Your Own" sharing
 * option under Urban Harvest.
 *
 * Route: /food-pulse/urban-harvest/pick-your-own
 */
import { Sprout } from "lucide-react";
import UrbanHarvestArticleLayout, { UH_PALETTE } from "@/components/UrbanHarvestArticleLayout";

export default function FoodPulseUrbanHarvestPickYourOwn() {
  return (
    <UrbanHarvestArticleLayout
      slug="pick-your-own"
      title="Pick Your Own"
      subtitle="Share Your Harvest, Your Way"
      icon={Sprout}
      accent={UH_PALETTE.leaf}
      body={[
        "Many homeowners enjoy harvesting the fruits and vegetables they have carefully grown, but often discover they have far more than their family can use. Instead of letting that abundance go to waste, Pick Your Own allows you to harvest at your own pace and decide exactly what you'd like to share.",
        "With this option, you remain completely in control. Harvest your fruit, vegetables, herbs, or garden produce whenever it is most convenient, then use FoodPulse to notify nearby families, neighbors, community groups, or participating organizations that your fresh harvest is available.",
        "You choose how much to share, when it is available, and who can receive it. Whether it's a basket of lemons, several pounds of tomatoes, extra zucchini, fresh herbs, or seasonal avocados, every contribution helps reduce food waste while bringing fresh, nutritious food into the community.",
        "FoodPulse provides information about your harvest, general pickup instructions if you choose to share them, and tools for coordinating collection while protecting your privacy.",
      ]}
      pullquote="Sometimes making a difference is as simple as harvesting one extra basket of fruit."
      closer="Every home can become part of a healthier community, one harvest at a time."
    />
  );
}
